import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, BookIcon as TiktokIcon, Pointer as Pinterest, Snail as Snapchat, MessageSquare, Send, Globe } from 'lucide-react';

interface SocialIconProps {
  platform: string;
  size?: number;
  color?: string;
  className?: string;
}

// Custom TikTok icon since it's not in Lucide
const CustomTiktokIcon: React.FC<{ size?: number, color?: string, className?: string }> = ({ 
  size = 24, 
  color = 'currentColor',
  className = ''
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export const SocialIcon: React.FC<SocialIconProps> = ({ 
  platform, 
  size = 24, 
  color = 'currentColor',
  className = ''
}) => {
  // Normalize platform name for comparison
  const normalizedPlatform = platform.toLowerCase().trim();
  
  switch (normalizedPlatform) {
    case 'facebook':
      return <Facebook size={size} color={color} className={className} />;
    case 'instagram':
      return <Instagram size={size} color={color} className={className} />;
    case 'twitter':
    case 'x':
      return <Twitter size={size} color={color} className={className} />;
    case 'linkedin':
      return <Linkedin size={size} color={color} className={className} />;
    case 'youtube':
      return <Youtube size={size} color={color} className={className} />;
    case 'tiktok':
      return <CustomTiktokIcon size={size} color={color} className={className} />;
    case 'pinterest':
      return <Pinterest size={size} color={color} className={className} />;
    case 'snapchat':
      return <Snapchat size={size} color={color} className={className} />;
    case 'whatsapp':
      return <MessageSquare size={size} color={color} className={className} />;
    case 'telegram':
      return <Send size={size} color={color} className={className} />;
    case 'other':
    default:
      return <Globe size={size} color={color} className={className} />;
  }
};